import React, { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../Config/axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Components/Loader/Loader";

const MOUContext = createContext();
export const useMOU = () => useContext(MOUContext);

export const MOUProvider = ({ children }) => {
  
  const [loading, setLoading] = useState(false);
  const [mouData, setMouData] = useState(null);

  const navigate = useNavigate();


  const checkMOUStatusForAll = async () => {
    let baseURL = `/customer/mou-form/status/` ;

    try {
      const response = await axiosInstance.get(baseURL);
      setMouData(response.data);
      return response.data;
      
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to fetch MOU status: ${err.message}`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };


   

  const checkMOUStatus = async (id) => {
    setLoading(true);

    let baseURL = `/customer/mou-form/status/?player_id=${id}` ;

    try {
      const response = await axiosInstance.get(baseURL);
      return response.data;
      
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to fetch MOU status: ${err.message}`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };


  const addMOUdata = async (data) => {
    setLoading(true);
    let baseURL = `/customer/mou-form/` ;
    try {
      const response = await axiosInstance.post(baseURL, data);
      return response.data;
      
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to add MOU form data: ${err.message}`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };



  const getMOUFormData = async (playerID) => {
    setLoading(true);
    let baseURL = `customer/mou-form/?player_id=${playerID}` ;
    try {
      const response = await axiosInstance.get(baseURL);
      return response.data;
      
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to fetch MOU form data: ${err.message}`,
        confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  

  
  
  return (
    <MOUContext.Provider 
        value={{
          mouData,
          checkMOUStatusForAll,
          checkMOUStatus, 
          addMOUdata, 
          getMOUFormData
        }}>
          {loading && (
          <Loader/>
          )}
          {children}
        </MOUContext.Provider>
      );
    };
